
const analyticsTypes = {
  PET_PARENT_ATTEMPT: 'ViewRegistration__PetParent',
  SIGNUP_VIEW: 'ViewRegistration__Account',
  SIGNUP_VIEW_BUYER: 'ViewRegistration__Buyer',
  SIGNUP_VIEW_VENDOR: 'ViewRegistration__Vendor',
  SIGNUP_COMPLETE: 'CompleteRegistration'
};

const analyticsActions = [{
  type: analyticsTypes.PET_PARENT_ATTEMPT
}, {
  type: analyticsTypes.SIGNUP_VIEW
}, {
  type: analyticsTypes.SIGNUP_VIEW_BUYER
}, {
  type: analyticsTypes.SIGNUP_VIEW_VENDOR
}, {
  type: analyticsTypes.SIGNUP_COMPLETE
}];

export {
  analyticsTypes,
  analyticsActions
};
